module.exports = __webpack_public_path__ + "f479fbc691f816dde9f92827740b56e1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/Bernadette.jpg
// module id = 695
// module chunks = 0